import { PIX_ISSUER_ID, PIX_ISSUER_ID_NAME } from '../data/constants';

const temporarilyDisabledIssuerIds: readonly string[] = [];

const isPixIssuer = (gatewayIssuerId?: string) => {
  return gatewayIssuerId === PIX_ISSUER_ID || gatewayIssuerId === PIX_ISSUER_ID_NAME;
};

const isPaymentMethodTemporarilyDisabled = (gatewayIssuerId?: string) => {
  return !!gatewayIssuerId && temporarilyDisabledIssuerIds.includes(gatewayIssuerId);
};

const isCurrencySupported = (currency: string, gatewayIssuerId: string, country: string) => {
  if (isPixIssuer(gatewayIssuerId) && currency === 'UYU') {
    return false;
  }

  // Disable all Argentinian payment methods (QR payments)
  if (country === 'ARG') {
    return false;
  }

  return true;
};

export const issuerHelper = {
  isPixIssuer,
  isPaymentMethodTemporarilyDisabled,
  isCurrencySupported,
};
